// ═══════════════════════════════════════════════════════════════════════════
//  TUTUP KEYBOARD TABLET (27 Okt 2026)
//
//  Zaldy: "klik ceklis di keyboard tab nggak nutup keyboardnya (Huawei)".
//  Di peramban biasa, blur() pada input sudah menutup keyboard. Di APK remote
//  (WebView Flutter) keyboard dikelola Flutter, dan blur() dari dalam web
//  tidak selalu menurunkannya. APK menyediakan jembatan `TutupKeyboard`
//  (karaoke-flutter main.dart → SystemChannels.textInput 'TextInput.hide');
//  kalau ada, dipanggil juga. Tanpa jembatan (peramban) tidak ada efek samping.
// ═══════════════════════════════════════════════════════════════════════════
export function tutupKeyboard(el?: HTMLElement | null) {
  try { (el ?? (document.activeElement as HTMLElement | null))?.blur() } catch { /* */ }
  try {
    const w = window as unknown as { TutupKeyboard?: { postMessage: (s: string) => void } }
    w.TutupKeyboard?.postMessage('tutup')
  } catch { /* */ }
}
